import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        surveyGroup: '=',
        company: '=',
        sites: '=',
        classifiers: '=',
        comparisonGroups: '='
    },
    template: `
        <div style="margin-top:20px; position:relative; height:200px" ng-if="vm.loading">
            <div class="loader02">{{ 'survey.Please wait! Loading report' | translate }}</div>
        </div>
        <ul class="actions01">
            <li><a class="btn filter" ng-click="vm.toggleFilter()">{{ 'filter.Filter report' | translate }}</a></li>
            <li><a class="btn ico-reports" ng-click="vm.toggleCompare()">{{ 'filter.Compare report' | translate }}</a></li>
        </ul>
        <survey-public-report-filter-report
            show-filter="vm.showFilter"
            sites="vm.sites"
            classifiers="vm.classifiers"
            filter="vm.filter"
            errors="vm.errors"
            show-individual-answers="vm.showIndividualAnswers"
        />
        <survey-public-report-compare-report
            show-compare="vm.showCompare"
            sites="vm.sites"
            classifiers="vm.classifiers"
            filter="vm.compareFilter"
            errors="vm.errors"
            comparison-groups="vm.comparisonGroups"
        />
        <ng-container ng-if="!vm.loading && !vm.errors">

            <div>
                <h3>{{ 'report.Total results' | translate }}</h3>
                <ul class="metablock">
                    <li>
                        <div class="label">{{ 'report.Number of participants responded' | translate }}</div>
                        <div class="value">{{ vm.report.totalAnswered }}</div>
                    </li>
                    <li>
                        <div class="label">{{ 'report.Total invited' | translate }}</div>
                        <div class="value">{{ vm.report.totalInvited }}</div>
                    </li>
                </ul>
            </div>

            <h2>{{ 'survey.Report introduction header' | translate }}</h2>
            <p ng-bind-html="vm.introduction"></p>
            <survey-public-report-no-answer ng-if="!vm.report.categoriesForm.hasAnswers"
            />
            <survey-public-report-category-summary ng-if="vm.report.categoriesForm.hasAnswers"
                categories-form="vm.report.categoriesForm"
                comparison-categories-form="vm.comparisonReport.categoriesForm"
            />
            <survey-public-report-category-results ng-if="vm.report.categoriesForm.hasAnswers"
                categories-form="vm.report.categoriesForm"
                comparison-categories-form="vm.comparisonReport.categoriesForm"
                question-counter="vm.questionCounter"
                comparison-question-counter="vm.comparisonQuestionCounter"
                title="vm.surveyGroup.activeI18n.name"
                compare-title="vm.compare"
                show-individual-answers="vm.showIndividualAnswers"
            />
            <survey-public-report-results ng-if="vm.report.categoriesForm.hasAnswers"
                question-counter="vm.questionCounter"
                questions="vm.report.categoriesForm.questionsWithoutCategories"
                comparison-question-counter="vm.comparisonQuestionCounter"
                comparison-questions="vm.comparisonReport.categoriesForm.questionsWithoutCategories"
                title="vm.surveyGroup.activeI18n.name"
                compare-title="vm.compare"
                show-individual-answers="vm.showIndividualAnswers"
            />

        </ng-container>
    `
})
export default class {
    constructor ($q, $rootScope, $scope, $state, $stateParams, $translate, MomentService, lodash, SurveyGroupResource,
        ResponseService, moment) {
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.MomentService = MomentService;
        this.language = $translate.use();
        this.lodash = lodash;
        this.SurveyGroupResource = SurveyGroupResource;
        this.ResponseService = ResponseService;
        this.moment = moment;
        this.$state = $state;
        this.$q = $q;
        this.compare = false;

        this.showIndividualAnswers = false;

        const listener = $rootScope.$on('survey:language', (event, language) => {
            this.language = language;
            this.introduction = this.getIntroduction();
            this.$onInit();
        });
        $scope.$on('$destroy', listener);
    }

    $onInit () {
        this.filter = {
            _lang: this.language,
            fallbackLanguage: this.surveyGroup.companyLanguage,
            sort: 'sequence'
        };

        this.filter.to = this.moment().format('YYYY-MM-DD');

        this.compareFilter = {
            _lang: this.language,
            fallbackLanguage: this.surveyGroup.companyLanguage,
            sort: 'sequence'
        };

        this.compareFilter.to = this.moment().format('YYYY-MM-DD');

        this.errros = [];

        this.introduction = this.getIntroduction();
        this.loadReport();
    }

    toggleFilter () {
        this.showFilter = !this.showFilter;
    }

    toggleCompare () {
        this.showCompare = !this.showCompare;
    }

    getIntroduction () {
        const textParams = {
            company: this.company.name,
            group_deadline: this.MomentService.formatTimeStamp(this.surveyGroup.deadline)
        };
        let introduction = this.$translate.instant(
            'survey.report_introduction_text', textParams, undefined, this.language.toLowerCase()
        );

        const companyI18n = this.lodash.find(this.company.companySurveyI18ns, (i18n) => {
            return this.language.toUpperCase() === i18n.language;
        });

        if (companyI18n && companyI18n.surveyReportIntroduction !== null) {
            introduction = companyI18n.surveyReportIntroduction;
        }
        return introduction;
    }

    compareReport () {
        this.loadReport(true);
    }

    loadReport (compare = false) {
        this.loading = true;
        this.errors = false;
        this.compare = false;

        const promises = {
            report: this.getReport(this.$state.params.guid, this.filter)
        };
        if (compare) {
            this.compare = true;
            const guid = this.compareFilter.comparisonGuid ? this.compareFilter.comparisonGuid : this.$state.params.guid;
            promises.comparisonReport = this.getReport(guid, this.compareFilter);
        }
        else {
            this.comparisonReport = null;
        }

        this.$q
        .all(promises)
        .then(reports => {
            this.report = reports.report;
            if (reports.comparisonReport) {
                this.comparisonReport = reports.comparisonReport;
                this.initComparisonQuestionCounter();
            }

            this.initQuestionCounter();
            this.$rootScope.report = this.report;
            this.loading = false;
        }).catch((response) => {
            this.loading = false;
            this.errors = this.ResponseService.parseErrors(response);
        });
    }

    getReport (guid, filter) {
        return this.SurveyGroupResource.report(
            { guid, _lang: this.language, fallbackLanguage: this.surveyGroup.companyLanguage }, filter
        ).$promise;
    }

    initQuestionCounter () {
        this.questionCounter = {};
        let counter = 1;
        this.lodash.forEach(this.report.categoriesForm.categories, (category) => {
            this.lodash.forEach(category.questions, (question) => {
                this.questionCounter[question.id] = counter;
                counter = counter + 1;
            });
        });
        this.lodash.forEach(this.report.categoriesForm.questionsWithoutCategories, (question) => {
            this.questionCounter[question.id] = counter;
            counter = counter + 1;
        });
    }

    initComparisonQuestionCounter () {
        this.comparisonQuestionCounter = {};
        let counter = 1;
        this.lodash.forEach(this.comparisonReport.categoriesForm.categories, (category) => {
            this.lodash.forEach(category.questions, (question) => {
                this.comparisonQuestionCounter[question.id] = counter;
                counter = counter + 1;
            });
        });
        this.lodash.forEach(this.comparisonReport.categoriesForm.questionsWithoutCategories, (question) => {
            this.comparisonQuestionCounter[question.id] = counter;
            counter = counter + 1;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/report/index.js